export default __webpack_public_path__ + "static/media/CarDetailingAllFinish.47977d3f.webp";